<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";

/**
 * Invoice-detail component
 */
export default {
    components: { ErrorMessage,Layout, PageHeader },
    data() {
        return {
            errorMessage: "",
            title: "Ticket Details",
            items: [
                {
                    text: "Booking",
                    href: "/"
                },
                {
                    text: "Ticket",
                    active: true
                }
            ],
            errors: null,
            bookingId:"",
            agent:"",
            passengers:[],
            booking:"",
            status:"",
            visible:false,
            message:"",
        };
    },
    created() {
        this.bookingId = this.$route.params.id;
    },
    mounted() {
        this.getBookingDetail();
    },
    methods: {
        onClose(){
            this.visible=false;
        },
        async getBookingDetail() {
            try {
                axios
                    .post("/api/flight-booking/details/" + this.bookingId, {
                        accessToken: localStorage.getItem("access_tocken"),
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.passengers=response.data.data.passengers;
                            this.booking=response.data.data.booking;
                           this.status=response.data.data.status;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
        errorCheck(obj) {
            if(obj.statusCode == 403){
                this.visible=true;
                this.message="Access Permission Denied";
                this.errors = obj.message;
            }else if (obj.error) {
                this.errors = obj.message;
            } else if (obj.message == "Token has expired") {
                this.$swal.fire({
                    title: 'LogOut!',
                    text: 'Token Has Expired',
                    icon: 'error',
                    toast:'true',
                    position: 'top-end',
                });
                this.$router.push({ name: "logout" });
            } else if (
                obj.message !== "Token has expired" &&
                obj.message !== "The given data was invalid."
            ) {
                this.errors = obj.message;
            } else if (obj.message == "The given data was invalid.") {
                this.errors = obj.errors;
            } else {
                this.flashMessage.show({
                    time: 5000,
                    status: "error",
                    title: "Error",
                    message: "Problem in data save",
                });
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="booking">
                            <h4>Booking Info</h4>
<!--                            <table>-->
                                <tr>
                                    <td>
                                        <label>Status</label>
                                    </td>
                                    <td>
                                        {{status.status_name}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Airline Pnr</label>
                                    </td>
                                    <td>
                                        {{booking.airline_pnr}}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Api Pnr</label>
                                    </td>
                                    <td>
                                        {{booking.api_pnr}}
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        <label>Base Fare</label>
                                    </td>
                                    <td>
                                       {{booking.base_fare}}
                                    </td>
                                </tr>
                            <tr>
                                <td>
                                    <label>Tax</label>
                                </td>
                                <td>
                                    {{booking.total_tax}}
                                </td>
                            </tr>
                                <tr>
                                    <td>
                                        <label>Gross Fare</label>
                                    </td>
                                    <td>
                                       {{booking.gross_fare}}
                                    </td>
                                </tr>
                            <tr>
                                <td>
                                    <label>Ait</label>
                                </td>
                                <td>
                                    {{booking.ait}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Markup</label>
                                </td>
                                <td>
                                    {{booking.markup}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Commission</label>
                                </td>
                                <td>
                                    {{booking.commission}}
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <label>Invoice Fare</label>
                                </td>
                                <td>
                                    {{booking.invoice_fare}} {{booking.currency}}
                                </td>
                            </tr>
                                <tr>
                                    <td>
                                        <label>Airline</label>
                                    </td>
                                    <td>
                                        {{booking.airline}}
                                    </td>
                                </tr>
                            <tr>
                                <td>
                                    <label>Payment Status</label>
                                </td>
                                <td v-if="booking.payment_status==0"><label>Pending</label></td>
                                <td v-else><label>Confirmed</label></td>
                            </tr>

                                <div class="row padding-2percent">
                                    <div class="col flight-seg" v-for="(flight,index) in booking.flight_segments"  v-bind:key="index">
                                        <h4>Flight Info {{index+1}}</h4>
                                        <tr>
                                            <td>
                                                <label>Flight Number </label>
                                            </td>
                                            <td>
                                                {{flight.operating_flight_number}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Arrival </label>
                                            </td>
                                            <td >
                                                {{flight.origin_code}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Arrival Date</label>
                                            </td>
                                            <td >
                                               {{flight.arrival_date }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Destination</label>
                                            </td>
                                            <td >
                                                {{flight.destination_code}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <label>Destination Date</label>
                                            </td>
                                            <td >
                                               {{flight.destination_date }}
                                            </td>
                                        </tr>
                                    </div>
                                </div>
<!--                            </table>-->
                            <br>
                        </div>
                        <div>

<!--                            <table>-->
                               <div class="row">
                                   <div class="col passenger" v-for="(passenger,index) in passengers" v-bind:key="index">
                                       <h4>Passenger {{index+1}}</h4>
                                       <tr>
                                           <td>
                                               <label> Passenger Name </label><br>

                                           </td>
                                           <td>
                                               {{passenger.prefix}} {{passenger.first_name}} {{passenger.last_name}}

                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label>Birth Date</label>
                                           </td>
                                           <td>
                                               {{passenger.date_of_birth}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label>Passenger Type</label>
                                           </td>
                                           <td>
                                               {{passenger.passenger_type}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label>Gender </label>
                                           </td>
                                           <td>
                                               {{passenger.gender}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label>Nationality</label>
                                           </td>
                                           <td>
                                               {{passenger.nationality}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label> Passport No.</label>
                                           </td>
                                           <td>
                                               {{passenger.passport_no}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label>Ticket No</label>

                                           </td>
                                           <td v-if="passenger.flight_ticket==null">
                                               Not Confirmed
                                           </td>
                                           <td v-else>
                                               {{passenger.flight_ticket.ticket_no}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label> Base Fare</label>
                                           </td>
                                           <td>
                                               {{passenger.base_fare}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label> Total Tax</label>
                                           </td>
                                           <td>
                                               {{passenger.total_tax}}
                                           </td>
                                       </tr>
                                       <tr>
                                           <td>
                                               <label> Gross Fare</label>
                                           </td>
                                           <td>
                                               {{passenger.gross_fare}}
                                           </td>
                                       </tr>
                                   </div>
                               </div>
<!--                            </table>-->
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>

<style scoped>
.flight-seg>tr>td{
    width:56.5%;
    height:30px;
}
.passenger>tr>td{
    width:35%;
    height:30px;
}
.booking>tr>td{
    width:32.5%;
    height:30px;
}
.flight-seg{
    padding-top: 2%;
}
/*.padding-2percent{*/
/*    padding-top: 2%;*/
/*}*/
</style>
